export default __webpack_public_path__ + "static/media/Logo-white.c56d3669.svg";